export const getNameAndLastName = (name = "", lastName = ""): string => {
  return `${name || ""} ${lastName || ""} `;
};
